import { render } from "./BusinessCardManagement.vue?vue&type=template&id=7732dd9d&scoped=true"
import script from "./BusinessCardManagement.vue?vue&type=script&lang=js"
export * from "./BusinessCardManagement.vue?vue&type=script&lang=js"

import "./BusinessCardManagement.vue?vue&type=style&index=0&id=7732dd9d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7732dd9d"]])

export default __exports__